module.exports = {
  maxWidth: 1140,
  breakpoint: 990,
  colors: {
    dark: "#000",
    blue: "#334cff",
  },
  animationDuration: 2500,
}
